export default __webpack_public_path__ + "static/demolition-chimney_removal-9b7612785ffebe62bb778cd0e9622926.png";